<template>
    <div class="regulation-form">
        <panel-competition-form-box class="regulation-form__box mab16">
            <div class="col-12 col-lg-8">
                <p class="form-input__label">Regulamin zawodów</p>
                <panel-input-base-radio
                    v-model="form.type"
                    name="statuteType"
                    :option="{ value: 'file', title: 'Wgraj plik' }"
                />
                <div
                    class="regulation-form__nested"
                    :class="{ 'regulation-form__nested--disabled': form.type !== 'file' }"
                >
                    <base-input-file
                        v-model="form.file"
                        :is-multiple="false"
                        accept=".pdf"
                        converter="base64"
                        hint="Wybierz plik"
                        :disabled="form.type !== 'file'"
                    />
                    <div v-if="showFileCurrent" class="regulation-form__file-current mat16">
                        <a :href="previewHref" target="_blank" rel="noopener noreferrer">{{ currentFileName }}</a>
                        <div class="mat8">
                            <base-button
                                btn2
                                short
                                :loading="removing"
                                :disabled="saving || removing"
                                @click="onRemove"
                            >
                                Usuń plik
                            </base-button>
                        </div>
                    </div>
                </div>
                <panel-input-base-radio
                    v-model="form.type"
                    name="statuteType"
                    :option="{ value: 'link', title: 'Regulamin pod linkiem' }"
                />
                <div
                    class="regulation-form__nested"
                    :class="{ 'regulation-form__nested--disabled': form.type !== 'link' }"
                >
                    <panel-input-text v-model="form.link" hint="http://" />
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <p class="form-input__hint">
                    Dodaj regulamin w pliku PDF lub podaj link do regulaminu na zewnętrznej stronie.
                    <br /><br />
                    Link może prowadzić do strony html lub bezpośrednio do pliku z regulaminem.
                    <br /><br />
                    Maksymalny rozmiar pliku: 2,5 MB (PDF).
                </p>
            </div>
        </panel-competition-form-box>

        <div class="regulation-form__actions mat24 mab24">
            <base-button btn1 :loading="saving" :disabled="saving || removing" @click="onSave">Zapisz</base-button>
        </div>
    </div>
</template>

<script>
    import PanelCompetitionFormBox from '@/components/PanelCompetitionFormBox';
    import PanelInputBaseRadio from '@/components/PanelInputBaseRadio';
    import PanelInputText from '@/components/PanelInputText';

    export default {
        name: 'PanelCompetitionRegulationForm',
        components: {
            PanelCompetitionFormBox,
            PanelInputBaseRadio,
            PanelInputText,
        },
        props: {
            value: {
                type: Object,
                required: true,
            },
            saving: {
                type: Boolean,
                default: false,
            },
            removing: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            form: {
                get() {
                    return this.value;
                },
                set(next) {
                    this.$emit('input', next);
                },
            },
            current() {
                return (this.form && this.form.current) || {};
            },
            showFileCurrent() {
                return this.current.type === 'file' && Boolean(this.current.path);
            },
            currentFileName() {
                const path = String(this.current.path || '');
                if (!path) {
                    return '';
                }
                const parts = path.split(/[/\\]/);
                return parts[parts.length - 1] || path;
            },
            previewHref() {
                const { path } = this.current;
                if (!path) {
                    return '#';
                }
                if (/^https?:\/\//i.test(path)) {
                    return path;
                }
                if (path.charAt(0) === '/') {
                    return path;
                }
                return `/${path}`;
            },
        },
        methods: {
            onSave() {
                this.$emit('save');
            },
            onRemove() {
                this.$emit('remove');
            },
        },
    };
</script>

<style scoped>
    .regulation-form {
        width: 100%;
    }
    .regulation-form .form.regulation-form__box {
        padding: 24px 16px;
        overflow: visible;
    }
    .form-input__label {
        margin: 0 0 16px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: var(--color-white);
    }
    .form-input__hint {
        margin-top: 16px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: var(--color-white);
    }
    .regulation-form__nested {
        margin: 8px 0 16px 7px;
        padding-left: 16px;
        border-left: 1px solid #78909c;
        min-height: 32px;
    }
    .regulation-form__nested--disabled {
        opacity: 0.5;
        pointer-events: none;
    }
    .regulation-form__file-current a {
        color: var(--color-white);
        text-decoration: underline;
        word-break: break-all;
    }
    .regulation-form__actions {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        justify-content: flex-end;
        align-items: center;
    }
    @media (min-width: 992px) {
        .regulation-form .form.regulation-form__box {
            padding: 24px 32px;
        }
        .form-input__hint {
            margin-left: 15px;
            margin-top: 0;
        }
    }
</style>
